import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {Dayjs} from "dayjs";
import React from "react";
import {PaymentPlanFrequency} from "../../../../enums";
import {DATE_FORMAT_V3, formatCurrency} from "../../../../helpers";
import {Card, Colors, Container, Text} from "../../../../ui";
import {paymentPlanFrequencyInfoMap} from "../../../constants";
import {datePickerStyle} from "../../../helpers";
import {Dialog} from "../../../bounce-ui";

export interface ReschedulePlanDialogContentProps {
  frequency: PaymentPlanFrequency;
  installmentAmountCents: number;
  selectedDate: Dayjs;
  minDate: Dayjs;
  maxDate: Dayjs;
  shouldDisableDate: (date: Dayjs) => boolean;
  onDateChange: (date: Dayjs) => void;
  isMobile: boolean;
  onConfirm: () => void;
  isLoading: boolean;
  isDateValid: boolean;
}

export const ReschedulePlanDialogContent = ({
  frequency,
  installmentAmountCents,
  selectedDate,
  minDate,
  maxDate,
  shouldDisableDate,
  onDateChange,
  isMobile,
  onConfirm,
  isLoading,
  isDateValid,
}: ReschedulePlanDialogContentProps) => {
  return (
    <Dialog
      title="Reschedule plan"
      buttonText="Update plan"
      onClick={onConfirm}
      disabled={!isDateValid || isLoading}
      autoClose={false}
      width={isMobile ? "100%" : "320px"}
    >
      <Container fullWidth sx={{gap: "24px"}}>
        <Text variant="inter400" size={16} sx={{color: Colors.grey._1000}}>
          This will update your entire plan. You can reschedule once every 6 months.
        </Text>

        <Card
          fullWidth
          sx={{
            alignItems: "start",
            padding: "16px",
            backgroundColor: Colors.tertiary._100,
            gap: "8px",
          }}
        >
          <Container sx={{gap: "8px"}}>
            <Container fullWidth sx={{alignItems: "start", gap: "0px"}}>
              <Text variant="inter400" size={12} sx={{color: Colors.grey._700}}>
                Frequency
              </Text>
              <Text variant="interDisplay600" size={18}>
                {paymentPlanFrequencyInfoMap.get(frequency)?.labelKey || frequency}
              </Text>
            </Container>
            <Container fullWidth sx={{alignItems: "start", gap: "0px"}}>
              <Text variant="inter400" size={12} sx={{color: Colors.grey._700}}>
                Installment amount
              </Text>
              <Text variant="interDisplay600" size={18}>
                {formatCurrency(installmentAmountCents)}
              </Text>
            </Container>
          </Container>
        </Card>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="New payment date"
            value={selectedDate}
            onChange={(date) => {
              if (date) {
                onDateChange(date);
              }
            }}
            minDate={minDate}
            maxDate={maxDate}
            shouldDisableDate={shouldDisableDate}
            sx={{width: "100%"}}
            slotProps={{
              ...datePickerStyle(isMobile),
              textField: {
                ...datePickerStyle(isMobile)?.textField,
                error: false,
              },
            }}
            format={DATE_FORMAT_V3}
          />
        </LocalizationProvider>
      </Container>
    </Dialog>
  );
};
